import ApiService from './ApiService'

export async function apiGetHuduCompanies(data = {}) {
    return ApiService.fetchData({
        url: '/article/hudu-companies',
        method: 'post',
        data,
    })
}

export async function apiGetHuduFolders(data = {}) {
    return ApiService.fetchData({
        url: '/article/hudu-folders',
        method: 'post',
        data,
    })
}

export async function apiGetHuduArticles(data = {}) {
    return ApiService.fetchData({
        url: '/article/hudu-articles',
        method: 'post',
        data,
    })
}

export async function apiPublishToHudu(data = {}) {
    return ApiService.fetchData({
        url: '/article/hudu-publish',
        method: 'post',
        data,
    })
}

export async function apiSearchHuduAssets(data = {}) {
    return ApiService.fetchData({
        url: '/article/hudu-assets',
        method: 'post',
        data,
    })
}
